import { createVNode as l, mergeProps as i } from "vue";
import n from "../node_modules/@pf-ui/pf-icon-svg/es/asn/AlertOutlined.js";
import m from "../components/PfIcon.js";
const t = (r, e) => {
  const o = {
    ...r,
    ...e.attrs
  };
  return l(m, i(o, {
    icon: n
  }), null);
};
t.displayName = "AlertOutlined";
t.inheritAttrs = !1;
export {
  t as default
};
